export default "__VITE_ASSET__RzqCd0l$__"